import { Injectable } from '@angular/core';
import { HttpEventType, HttpParams } from '@angular/common/http';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export type ConflictResolution = 'overwrite' | 'keepBoth';

export interface IDocumentOperationResult {
  conflicts: string[] | null;
  documents: any[] | null;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private httpService: HttpService) {}

  getDocuments(path: string | null): Observable<any> {
    let params = new HttpParams();
    if (path) {
      params = params.set('path', path);
    }
    return this.httpService.get('documents', { params });
  }

  createDocumentDir(parentPath: string | null, name: string): Observable<any> {
    return this.httpService.post('documents/directory', { parentPath, name });
  }

  renameDocument(path: string, isDirectory: boolean, newName: string): Observable<any> {
    return this.httpService.post('documents/rename', { path, isDirectory, newName });
  }

  deleteDocuments(targets: { path: string; isDirectory: boolean }[]): Observable<any> {
    return this.httpService.post('documents/delete', targets);
  }

  uploadDocuments(parentPath: string | null, files: File[] | FileList, resolution?: ConflictResolution): Observable<IDocumentOperationResult> {
    const formData = new FormData();
    if (parentPath) {
      formData.append('parentPath', parentPath);
    }
    Array.from(files).forEach((file) => formData.append('files', file));
    if (resolution) {
      formData.append('resolution', resolution);
    }
    return this.httpService.post('documents/upload', formData);
  }

  downloadDocument(path: string) {
    return this.httpService.downloadFile(`documents/download?path=${encodeURIComponent(path)}`);
  }
  
  getDocumentBlob(path: string): Observable<Blob> {
    return this.downloadDocument(path).pipe(
      filter((event: any) => event.type === HttpEventType.Response),
      map((event: any) => event.body as Blob)
    );
  }

  moveDocuments(targets: { path: string; isDirectory: boolean }[], destinationParentPath: string | null, resolution?: ConflictResolution): Observable<IDocumentOperationResult> {
    return this.httpService.post('documents/move', { targets, destinationParentPath, resolution });
  }

  copyDocuments(targets: { path: string; isDirectory: boolean }[], destinationParentPath: string | null, resolution?: ConflictResolution): Observable<IDocumentOperationResult> {
    return this.httpService.post('documents/copy', { targets, destinationParentPath, resolution });
  }
}
